import {ErrorHandler, Injectable} from "@angular/core";
import {Monitor} from "./monitor.service";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private insights: Monitor) {}

    handleError(error: any): void {
        // Send to Application Insights
        this.insights.trackException(error);

        console.error("Global Error caught:", error);

        // re-throw
        // throw error;
    }
}
